// import { toast } from "react-toastify";
import ProductCard from "../../../components/common/ProductCard";
import { ProductService } from "../../../services/productService";
import { useEffect, useState } from "react";

const RelatedProducts = ({ productIds = [], category }) => {
  const [products, setProducts] = useState([]);
  const fetchProducts = async () => {
    try {
      const response = await ProductService.getListProducts({
        page: 1,
        pageSize: 5,
        productIds: productIds,
        category: productIds.length === 0 ? category : "",
      });
      if (!response.Data) {
        // toast.error("Lỗi lấy danh sách sản phẩm!");
        return;
      }
      const { listData } = response.Data;
      setProducts(listData);
    } catch (error) {
      // toast.error("Lỗi lấy danh sách sản phẩm!");
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-white p-6 w-full lg:px-24">
      {/* Title */}
      <div className="mb-6">
        <span className="font-bold">Sản phẩm liên quan</span>
      </div>

      {/* Product Grid */}
      <div className="grid gap-4 grid-cols-2 lg:grid-cols-5 grid-rows-2 lg:grid-rows-1">
        {products.slice(0, 5).map((p, i) => (
          <div key={p._id || i} className={i >= 4 ? "hidden lg:block" : ""}>
            <ProductCard product={p} />
          </div>
        ))}
      </div>

      {/* View All */}
      <div className="mt-6 text-center">
        <a
          href={`/products/${category}`}
          className="text-primaryColor underline hover:text-blue-500"
        >
          Xem tất cả sản phẩm
        </a>
      </div>
    </div>
  );
};
export default RelatedProducts;
